import { formatCnpj, hasAnyLetter } from '@/utils/regex-utils';

export default {
  searchText(state) {
    return state.searchText;
  },
  listOptions(state) {
    return state.listOptions;
  },
  stringFilter(state) {
    let filter = '';
    if (state.searchText) {
      const cnpjQuery = !hasAnyLetter(state.searchText) ? ` or cnpj like '%${formatCnpj(state.searchText)}%' or documento like '%${formatCnpj(state.searchText)}%'` : '';
      filter = `nome like '%${state.searchText.toLowerCase()}%' or codigoInterno like '%${state.searchText.toLowerCase()}%' or nomePersonalizado like '%${state.searchText.toLowerCase()}%'${cnpjQuery}`;
    }
    return filter;
  },
};
